import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TenantCreateForm from "../../components/admin/TenantCreateForm";
import PageHeader from "../../components/admin/PageHeader";
import { createTenant } from "../../api/tenantApi";

const TenantCreatePage = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const handleSubmit = async (payload) => {
		setLoading(true);
		setErrorMessage("");

		try {
			const response = await createTenant(payload);
			const tenantId = response?.data?.id || response?.data?.tenant_id || response?.id;
			if (tenantId) {
				navigate(`/agents/${tenantId}`, { replace: true, state: { toast: "Tenant created successfully" } });
				return;
			}

			navigate("/agents", { replace: true, state: { toast: "Tenant created successfully" } });
		} catch (error) {
			setErrorMessage(error.message || "Failed to create tenant.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="space-y-6">
			<PageHeader
				eyebrow="Platform admin"
				title="Create tenant"
				description="Create a new client business tenant with the Phase 1 foundation fields."
			/>

			<TenantCreateForm onSubmit={handleSubmit} loading={loading} errorMessage={errorMessage} />
		</div>
	);
};

export default TenantCreatePage;
